import { gql } from '@apollo/client';

export const POST_COMPANY_REVIEW_MUTATE = gql`
  mutation Mutation($input: PostCompanyReviewInput!) {
    postCompanyReview(input: $input) {
      ... on PostCompanyReviewSuccess {
        reviewId
      }
      ... on PostCompanyReviewFailure {
        errors {
          message
        }
      }
    }
  }
`;

export const POST_COMPANY_REVIEW_EXPERIMENT_TWO_MUTATE = gql`
  mutation Mutation($input: PostCompanyReviewExperiment2Input!) {
    postCompanyReviewExperiment2(input: $input) {
      ... on PostCompanyReviewExperiment2Success {
        reviewId
      }
      ... on PostCompanyReviewExperiment2Failure {
        errors {
          message
        }
      }
    }
  }
`;
